import { ConfAccount } from "../context/account/paramsAccount";

const validateSignInfo = (info: any, showError: (msg: string) => void) => {
    if (info.e_nom_responsable && info.e_nom_responsable.length > 100) {
        showError("Le nom du responsable ne peut pas dépasser 100 caractères.");
        return false;
    }

    if (info.e_nom_client && info.e_nom_client.length > 100) {
        showError("Le nom du client ne peut pas dépasser 100 caractères.");
        return false;
    }

    if (info.e_lieu_signature && info.e_lieu_signature.length > 200) {
        showError("Le lieu de signature ne peut pas dépasser 200 caractères.");
        return false;
    }

    if (info.e_observation && info.e_observation.length > 5000) {
        showError("L'observation ne peut pas dépasser 5000 caractères.");
        return false;
    }

    return true;
};
export const validPrestationWithPhase = (id: string, key: string,
    showError: (message: string) => void, showModal: (message: string) => void, setDetails: any, conf: ConfAccount, setIndexPhase: any, indexPhase: number, maxIndex: number) => {
    setDetails((prevDetails: any) =>
        prevDetails.map((phase: any) => ({
            ...phase,
            sous_categorie: phase.sous_categorie.map((sub: any) => {
                if (sub.rpl_id === id) {
                    if (!validateSignInfo(sub.informationSign, showError)) { return { ...sub }; }
                    if (sub.informationSign.e_nom_responsable && sub.informationSign.e_lieu_signature && sub.informationSign.e_signature_client && sub.informationSign.e_signature_responsable) {
                        showModal(`La phase ${sub?.rpl_designation} a bien été enregistrée.`)
                        if (indexPhase + 1 < maxIndex) {
                            setIndexPhase(indexPhase + 1)
                        }

                        return {
                            ...sub,
                            [key]: true
                        };
                    } else {
                        showError(`Impossible de valider la phase ${sub?.rpl_designation} sans que tous les champs soient remplis.`)
                        return {
                            ...sub,
                        };
                    }
                } else {
                    return {
                        ...sub,
                    };
                }

            }),
        }))
    );

    const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
    let prestas = savedData ? JSON.parse(savedData) : [];
    const updatedPrestas = prestas.map((presta: any) => {
        if (presta.rpl_id === id && presta.informationSign.e_nom_responsable && presta.informationSign.e_lieu_signature && presta.informationSign.e_signature_client && presta.informationSign.e_signature_responsable) {
            return {
                ...presta,
                sous_categorie: presta.sous_categorie.map((sub: any) =>
                    sub.rpl_id === id ? { ...sub, [key]: true } : sub
                ),
            };
        } else showError("Impossible de valider la prestations.")
        return presta;
    });
    localStorage.setItem(`prestaHl_${conf.user.user_code}`, JSON.stringify(updatedPrestas));
};

export const validPrestation = (id: string, key: string,
    showError: (message: string) => void, showModal: (message: string) => void, setDetails: any, conf: ConfAccount) => {
    setDetails((prevDetails: any) => {

        // Vérifie si prevDetails est bien un tableau
        if (!Array.isArray(prevDetails)) return prevDetails;

        return prevDetails.map((detail) => {
            if (detail.rpl_id === id) {
                if (!validateSignInfo(detail.informationSign, showError)) {
                    return detail;
                }

                if (
                    detail.informationSign.e_nom_responsable &&
                    detail.informationSign.e_lieu_signature &&
                    detail.informationSign.e_signature_client &&
                    detail.informationSign.e_signature_responsable
                ) {
                    showModal(`La prestation a bien été enregistrée.`)
                    return {
                        ...detail,
                        [key]: true, // Mise à jour du champ
                    };
                } else {
                    showError(
                        `Impossible de valider la prestation sans que tous les champs soient remplis.`
                    );
                    return detail; // On garde l'élément inchangé
                }
            }
            return detail; // Retourne les autres éléments du tableau inchangés
        });
    });



    const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
    let prestas = savedData ? JSON.parse(savedData) : [];
    const updatedPrestas = prestas.map((presta: any) => {
        if (presta.rpl_id === id && presta.informationSign.e_nom_responsable && presta.informationSign.e_lieu_signature && presta.informationSign.e_signature_client && presta.informationSign.e_signature_responsable) {
            return {
                ...presta,
                sous_categorie: presta.sous_categorie.map((sub: any) =>
                    sub.rpl_id === id ? { ...sub, [key]: true } : sub
                ),
            };

        } else showError("Impossible de valider la prestations")
        return presta;
    });
    localStorage.setItem(`prestaHl_${conf.user.user_code}`, JSON.stringify(updatedPrestas));
};
